import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const consent = document.querySelector('.p-message__consent'),
  lightTop = document.querySelector('.p-message__img__light--top__picture'),
  lightBottom = document.querySelector('.p-message__img__light--bottom__picture'),
  consentLeft = document.querySelector('.p-message__img__consent--left__picture'),
  consentRight = document.querySelector('.p-message__img__consent--right__picture');

if (consent) {
  let consentLeftTl = gsap.timeline({
    scrollTrigger: {
      scrub: 1,
      trigger: consent,
      endTrigger: consent,
      start: 'top 80%',
      end: () => '+=' + (consent.clientHeight - 100),
      // markers: true,
    }
  })

  consentLeftTl.addLabel('start')
    .from(consentLeft, { left: -778.4, opacity: 0 }, 0)
    .to(consentLeft, { left: (-778.4 + 120), opacity: 1 }, .5)

    .from(consentRight, { right: (-847.56 + 388 - 120), opacity: 0 }, 0)
    .to(consentRight, { right: (-847.56 + 388), opacity: 1 }, .5)

    .from(lightTop, { top: '50%', opacity: 0, scaleX: .5 }, 0)
    .to(lightTop, { top: 'calc(50% - 184px)', opacity: 1, scaleX: 1 }, .5)

    .from(lightBottom, { top: '50%', opacity: 0, scale: .5 }, 0)
    .to(lightBottom, { top: 'calc(50% + 184px)', opacity: 1, scale: 1 }, .5)

    .addLabel('end');
}